<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  
    <!-- Data Peserta -->
    <CCardBody>
     <CRow>
       <FilterPesertaPelatihanOffline/>
     </CRow>
     
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable 
            class="w-100" 
            :items="items" 
            :fields="fields" 
            hover 
            sorter
          >
            <template #no="{index}">
              <td class="py-2">{{ indexed == 0 ? index +1: index+indexed + 1 }}</td>
            </template>
            <template #email="{item}">
              {{item.email ? item.email : '-'}}
            </template>
            <template #nama_lengkap="{ item }" >
            <td class="py-2" v-if="item.tipe_peserta == 'moderator'">
              {{ item.nama_instruktur ? item.nama_instruktur : "-" }}
            </td>
            <td class="py-2" v-else-if="item.tipe_peserta == 'instruktur'">
              {{ item.nama_instruktur ? item.nama_instruktur : "-" }}
            </td>
            <td class="py-2" v-else>
              {{ item.nama_lengkap ? item.nama_lengkap : "-" }}
            </td>
          </template>
             <template #tipe_peserta="{ item }">
            <td class="py-2" v-if="item.tipe_peserta == null"> Peserta</td>
            <td class="py-2" v-if="item.tipe_peserta == 'peserta'"> Peserta</td>
            <td class="py-2" v-if="item.tipe_peserta == 'instruktur'"> Instruktur</td>
            <td class="py-2" v-if="item.tipe_peserta == 'moderator'"> Moderator</td>
          </template>
            <template #status_pembayaran="{item}">
              <td
                class="py-2 font-weight-bold text-success"
                v-if="item.status_pembayaran_label == 'Lunas'"
              >
                Lunas
              </td>
              <td
                class="py-2 font-weight-bold text-danger"
                v-else-if="item.status_pembayaran_label == 'Expired'"
              >
                Expired
              </td>
              <td class="py-2 font-weight-bold text-warning" v-else>
                Belum Lunas
              </td>
            </template>
             <template #statusbatal="{ item }">
            <td
              class="py-2 text-success font-weight-bold"
              v-if="item.statusbatal == 'Disetujui'"
            >
              {{ item.statusbatal }}
            </td>
            <td
              class="py-2 text-danger font-weight-bold"
              v-else-if="item.statusbatal == 'Ditolak'"
            >
              {{ item.statusbatal }}
            </td>
            <td
              class="py-2 text-warning font-weight-bold"
              v-else-if="item.statusbatal == 'Pengajuan'"
            >
              {{ item.statusbatal }}
            </td>
            <td class="py-2 text-secondary font-weight-bold" v-else>
              {{ item.statusbatal }}
            </td>
          </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <CButton
                    v-c-tooltip="'Ubah Status Pembatalan'"
                    @click="aksiPembatalan(item)"
                    :disabled="
                      item.statusbatal == 'Tidak Ada Pengajuan' ||
                      item.statusbatal == null ||
                      item.statusbatal == 'Disetujui'
                    "
                    :color="
                      item.statusbatal == 'Tidak Ada Pengajuan' ||
                      item.statusbatal == null ||
                      item.statusbatal == 'Disetujui'
                        ? 'secondary'
                        : 'info'
                    "
                    class="btn-sm mr-2"
                    square
                  >
                    <i class="fa fa-coins" aria-hidden="true"></i>
                  </CButton> 
                <CButton
                v-if="item.status_biaya != 'gratis'"
                :disabled="
                  item.id_user === null ||
                  item.id_user === '' ||
                  item.id_user === '-' || item.status_pembayaran_label != 'Lunas'
                  || item.status_pembatalan == '1'|| item.status_pembatalan == '0' 
                "
                v-c-tooltip="'Upload Sertifikat'"
                class="mr-2"
                 :color="
                  item.id_user === null ||
                  item.id_user === '' ||
                  item.status_pembayaran_label != 'Lunas' ||
                  item.id_user === '-'
                  || item.status_pembatalan == '1'|| item.status_pembatalan == '0'  ? 'secondary' : 'info'
                "
                square
                size="sm"
                @click="uploadData(item, index)"
              >
                <font-awesome-icon icon="upload" />
              </CButton>
              <CButton
                v-else
                :disabled="
                  item.id_user === null ||
                  item.id_user === '' ||
                  item.id_user === '-' 
                  || item.status_pembatalan == '1'
                "
                v-c-tooltip="'Upload Sertifikat'"
                class="mr-2"
                 :color="
                  item.id_user === null ||
                  item.id_user === '' ||
                  item.id_user === '-'
                  || item.status_pembatalan == '1' ? 'secondary' : 'info'
                "
                square
                size="sm"
                @click="uploadData(item, index)"
              >
                <font-awesome-icon icon="upload" />
              </CButton>
                <CButton
                  v-c-tooltip="'Detail'"
                  color="success"
                  class="btn-sm mr-2"
                  square
                  @click="Detail(item.id_pelatihan_peserta)"
                >
                  <font-awesome-icon icon="eye" />
                </CButton>
                <CButton 
                  :color="item.status_dokumen_persyaratan == '0' || item.statusbatal  == 'Disetujui' || item.id_user == null || item.id_user == ''? 'secondary' : 'warning'"
                  class="btn-sm text-white" 
                  :disabled="item.status_dokumen_persyaratan == '0' || item.id_user == null || item.id_user == '' "
                  @click="pindahDokumen(item.id_pelatihan_peserta)"
                  square >
                  <font-awesome-icon icon="file" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="modalDetail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CRow>
          <div class="modal-body row my-n3">
            <div class="col-5">
              <p class="font-weight-bold">No Anggota</p>
              <p class="font-weight-bold">Nama Anggota</p>
              <p class="font-weight-bold">Email</p>
              <p class="font-weight-bold">No. Handphone</p>
              <p class="font-weight-bold">No. Telepon</p>
            </div>
            <div class="col-7">
              <p>: AGT-1</p>
              <p>: Samantha Wiliam</p>
              <p>: samantha@gmail.com</p>
              <p>: 087837432432</p>
              <p>: 034329423423</p>
            </div>
          </div>
        </CRow>
        <template #header>
          <h6 class="modal-title h5 font-weight-bold">Detail Anggota</h6>
        </template>
        <template #footer>
          <router-link to="/keanggotaan/data-anggota">
            <CButton color="info">Detail</CButton>
          </router-link>
          <CButton @click="modalDetail = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="modalDetailPeserta"
        :no-close-on-backdrop="true"
        :centered="true"
        size="lg"
      >
        <CRow class="px-3">
          <table class="table table-bordered font-weight-bold">
            <tr>
              <th class="bg-primary" style="width: 40%">No Lapor Pelatihan</th>
              <td>{{ detailPeserta.no_lapor_pelatihan ? detailPeserta.no_lapor_pelatihan : '-' }}</td>
            </tr>            
            <tr>
              <th class="bg-primary" style="width: 40%">Nama Pelatihan</th>
              <td>{{detailPeserta.nama_pelatihan ? detailPeserta.nama_pelatihan : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Tanggal Pendaftaran</th>
              <td>{{detailPeserta.tanggal_daftar ? detailPeserta.tanggal_daftar : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Status Pembayaran</th>
              <td>
                <span class="badge badge-success" v-if="detailPeserta.status_pembayaran_label   == 'Lunas'">
                  Lunas
                </span>
                <span class="badge badge-danger" v-else-if="detailPeserta.status_pembayaran_label   == 'Expired'">
                  Expired
                </span>
                <span class="badge badge-warning" v-else>
                  Belum Lunas
                </span>
              </td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Perolehan SKP Terstruktur</th>
              <td>{{detailPeserta.skp_terstruktur ? detailPeserta.skp_terstruktur : '0'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Perolehan SKP Non Terstruktur</th>
              <td>{{detailPeserta.skp_tidak_terstruktur ? detailPeserta.skp_tidak_terstruktur : '0'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Assesment</th>
              <td>{{detailPeserta.skp_assessment ? detailPeserta.skp_assessment : '0'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">E-Sertifikat</th>
              <td>
                <button class="btn btn-sm btn-secondary" disabled v-if="detailPeserta.file_sertifikat == null">Lihat File</button>
                <button class="btn btn-sm btn-warning" v-else @click="lihatFileDetail">Lihat File</button>
              </td>
            </tr>
          </table>
        </CRow>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail</h6>
        </template>
        <template #footer>
          <CButton @click="modalDetailPeserta = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
       <!-- Modal Upload File -->
    <ModalSertifikat 
    :modalUpload="modalUpload"
    :formData="formData" 
    :title="title" 
    :image="image"
    :tipePeserta="tipePeserta"
    :dataSertifikat="dataSertifikat"
    :actionPost="actionPost"
    :fileName="fileName"
    @closeModalUpload="closeModalUpload($event)"
    />
    <!-- End Modal -->
      <!-- Modal Pengajuan Pembatalan -->
        <ModalPengajuanPembatalan
          :modalDetailPembatalan="modalDetailPembatalan"
          :title="modalTitleDetailPembatalan"
          :formData="formDataPembatalan"       
          @closeModalPembatalan="closeModalPembatalan($event)"
        />
        <!-- Modal Pengajuan Pembatalan -->
    </CCardBody>
    <!-- End Data Peserta -->
</template>

<script>
import DataPesertaService from "@/services/pelatihan/data-peserta.service";
import FilterPesertaPelatihanOffline from "@/components/sertifikasi/datapeserta/FilterPesertaPelatihanOffline";
import ModalPengajuanPembatalan from '@/components/pelatihan/datapeserta/ModalPengajuanPembatalan';
import ModalSertifikat from "./ModalSertifikat";
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import BaseUrl from "@/services/base-url";
import Utils from "@/services/utils.service";

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "tanggal_daftar",
    label: "Tanggal Daftar",
    sorter: true,
    filter: false
  },
  {
    key: "tipe_peserta",
    label: "Tipe Peserta",
    sorter: true,
    filter: false,
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: false
  },
  {
    key: "statusbatal",
    label: "Status Pembatalan",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 11rem; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [
    AlertUtils, 
    Pagination,
    KategoriAnggota
  ],
  components : {
    FilterPesertaPelatihanOffline,
    ModalPengajuanPembatalan,
    ModalSertifikat
  },
  data() {
    return {
      image : "",
      baseUrl: "",
      tipePeserta : "",
      modelIdWorkshopPelatihan : '',
      
      pelatihan:'',
      kategori_anggota : '',
      items: [],
      dataSertifikat: [],
      detailPeserta: {
        id_keanggotaan: "",
        id_user: "",
        id_pelatihan_peserta: "",
        nama_pelatihan: "",
        id_workshop_pelatihan: "",
        no_anggota: "",
        nama_lengkap: "",
        tanggal_daftar: "",
        status_pembayaran: "",
        status_pembayaran_label: "",
        id_invoice: "",
        created_at: "",
        pelatihan_created_at: "",
        no_lapor_pelatihan: "",
        skp: "",
        file_sertifikat: "",
      },
      dataPelatihan: [],
      fields,
      details: [],
      title: '',
      actionPost: '',
      fileName: "Pilih File",
      status: false,
      myModal: false,
      modalDetail: false,
      modalUpload: false,
      modalDetailPeserta: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      formData: {},
      formDataPembatalan: {},
      modalDetailPembatalan: false,
      BaseUrl : '',
      modalTitleDetailPembatalan: "Detail Pembatalan",
    };
  },

  mounted() {
    this.BaseUrl = BaseUrl();
    this.baseUrl = BaseUrl();

    this.getAllKategoriAnggota();
    this.getPelatihan();
    this.getDetailPeserta();
  },

  methods: {
    pindahDokumen(id) {
      this.$router.push({ path: '/pelatihan/data-peserta-pelatihan/offline/data-dokumen/'+id })
    },
    pageChange() {
      this.getData(currenPage);
    },

    Detail(id_pelatihan_peserta) {
      this.modalDetailPeserta = true;
      this.getDetailPeserta(id_pelatihan_peserta);
    },

    dataTable(data) {
      var vm = this;
      vm.items = data.items;
      vm.pagination.totalPages = data.totalPages;
      vm.currentPage = data.currentPage;
    },

    getData(currentPage, pageSize, idWorkshopPelatihan, filter) {
      // if(this.modelIdWorkshopPelatihan != "") {
        var id_pelatihan = this.modelIdWorkshopPelatihan;
      // } else {
      //   return false;
      // }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;

      DataPesertaService.getDataPeserta(
        currentPage,
        pageSize,
        id_pelatihan,
        filter
      )
        .then(response => {
          loader.hide();

          // comment console console.log(response.data.data.content + "INI DI PELATIHAN");

          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getDetailPeserta(idPelatihanPeserta) {
      var vm = this;

      DataPesertaService.detailDataPeserta(idPelatihanPeserta)
      .then(response => {
          
          // comment console console.log(response.data.singleData);
          vm.detailPeserta.no_lapor_pelatihan = response.data.singleData.no_laporppl;;
          vm.detailPeserta.id_keanggotaan = response.data.singleData.id_keanggotaan;
          vm.detailPeserta.id_user = response.data.singleData.id_user;
          vm.detailPeserta.id_pelatihan_peserta = response.data.singleData.id_pelatihan_peserta;
          vm.detailPeserta.nama_pelatihan = response.data.singleData.nama_pelatihan;
          vm.detailPeserta.id_workshop_pelatihan = response.data.singleData.id_workshop_pelatihan;
          vm.detailPeserta.no_anggota = response.data.singleData.no_anggota;
          vm.detailPeserta.nama_lengkap = response.data.singleData.nama_lengkap;
          vm.detailPeserta.tanggal_daftar = response.data.singleData.tanggal_daftar;
          vm.detailPeserta.status_pembayaran = response.data.singleData.status_pembayaran;
          vm.detailPeserta.status_pembayaran_label = response.data.singleData.status_pembayaran_label;
          vm.detailPeserta.id_invoice = response.data.singleData.id_invoice;
          vm.detailPeserta.created_at = response.data.singleData.created_at;
          vm.detailPeserta.pelatihan_created_at = response.data.singleData.pelatihan_created_at;
          vm.detailPeserta.skp = "";
          vm.detailPeserta.file_sertifikat = response.data.singleData.file_sertifikat;
          vm.detailPeserta.status_biaya = response.data.singleData.status_biaya
          vm.detailPeserta.skp_terstruktur = response.data.singleData.skp_terstruktur
          vm.detailPeserta.skp_assessment = response.data.singleData.skp_assessment
          vm.detailPeserta.skp_tidak_terstruktur = response.data.singleData.skp_tidak_terstruktur
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getPelatihan() {
      var vm = this;
      DataPesertaService.getPelatihan()
      .then(response => {
        vm.dataPelatihan = response.data.data.content;
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },

    changePelatihan(value) {
      this.modelIdWorkshopPelatihan = value.id_workshop_pelatihan;      
      this.idWorkshopPelatihan = value.id_workshop_pelatihan;
      this.getData("0", this.pageSize, this.modelIdWorkshopPelatihan, this.searchPelatihan);
    },

    
    postData() {
      if (this.actionPost == "insert") {                
          this.insertData(this.formData);          
      } else if (this.actionPost == "update") {        
          this.putData();
        }
    },

    putData() {
       let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });  
      if (typeof this.formData.file === "string") {
        delete this.formData.file;
      }

      if (this.formData.file === null) {
        delete this.formData.file;
      }
      var vm = this;
      DataPesertaService.putSertifikat(this.formData)
        .then(response => {
          loader.hide();
          vm.modalUpload = false;
          vm.alertSuccess();
        })
        .catch(error => {
          loader.hide();
          this.alertError();
        });
    },

    uploadData(item) {
      DataPesertaService.getSertifikat(item.id_pelatihan_peserta)
      .then((response) => {
        this.dataSertifikat = response.data.singleData
      })
      .catch((error) => {
        console.log(error)
      });
      if (item.background_sertifikat == null) {
        this.image = "./img/background-sertifikat.png";
        // this.image = "./img/Screenshot 2021-10-01 100807.png";
      } else {
        this.image = this.BaseUrl+"/files?filename="+item.background_sertifikat+"&path=pelatihan@backgroundsertifikat";
      }
      this.tipePeserta = item.tipe_peserta
      // this.image = this.BaseUrl+""
      this.modalUpload = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Sertifikat";
      this.fileName = "Pilih File";
    },

    fileUpload(e) {
      this.formData.file = e.target.files[0];
      this.fileName = e.target.files[0].name;
    },

    lihatFileDetail() {
      let routeData =
          this.baseUrl +
          "/files?filename=" +
          this.detailPeserta.file_sertifikat +
          "&path=pelatihan@sertifikat";
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000`;
        window.open(
         routeData,
          this.detailPeserta.file_sertifikat,
          params
        );
    },
    lihatFileRefund(file) {
      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+file+"/lokasi/file_refund/bearer/" + token,
        file,
        params
      );
    },
    lihatFile() {
      let routeData =
          this.baseUrl +
          "/files?filename=" +
          this.formData.file_sertifikat +
          "&path=pelatihan@sertifikat";
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000`;
        window.open(
         routeData,
          this.formData.file_sertifikat,
          params
        );
      
    },

     postStatusPembatalan() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });      

      let vm = this;

      let status = this.formDataPembatalan.statusbatal === "Disetujui" ? '1' : '2';      

      let data = {
        idPelatihanPeserta: this.formDataPembatalan.id_pelatihan_peserta,
        statusPembatalan: status
      };

      DataPesertaService.putStatusPembatalan(data)
        .then((response) => {
          loader.hide();
          this.modalDetailPembatalan = false;
          this.alertEditSuccess();                  
        })
        .catch((error) => {
          this.alertError();
        });  
    },

    aksiPembatalan(item) {  
      this.modalDetailPembatalan = true;
      this.formDataPembatalan = item;          
    },   

    closeModalPembatalan(val) {      
      if(val === false) {
        this.modalDetailPembatalan = false
      }      
    },
    closeModalUpload(val) {
      if (val === false) {
        this.modalUpload = false;
      }
    },

    closeModalDetail(val) {
      if(val === false) {
        this.modalDetail = false;
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
